import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from "../../shared/common.service";

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {
  userData: any;
  userId: number;  
  filteredStudies: any[] = [];
  searchText: string = '';
  statusFilter: string = '';
  startDateFilter: string = '';
  endDateFilter: string = '';

  studyId: number;
  previousPage: number;
  searchSite = '';
  designationFilter = '';
  currentPage: number;


  constructor(private apiService: ApiService, private route: ActivatedRoute,private commonService: CommonService,
    private router: Router
  ) {}

  ngOnInit(): void {

    let userData = this.commonService.getUserData(); 

    if (userData == null) { // Check if user data is null
      this.commonService.logout(); // Call logout method
    }


    this.userId = +this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.searchText = params['searchText'] || '';
      this.searchSite = params['searchSite'] || '';
      this.designationFilter = params['designationFilter'] || '';
      this.statusFilter = params['statusFilter'] || '';
      this.currentPage = +params['page'] || 1;
    });

    this.getUserData();


  }

  getUserData(): void {
    this.apiService.getUser(this.userId).subscribe(
      (data: any) => {
        console.log('User data:', data);  
        console.log('Filtered Studies:', this.filteredStudies);// Log data to check structure
        this.userData = data;  // Assuming data is in the first index of an array
        this.filteredStudies = this.userData?.studies || [];
      },
      error => {
        console.error('Error fetching user data', error);
      }
    );
  }

  applyFilter(): void {
    if (!this.userData?.studies) return;  // Ensure studies exists
  
    this.filteredStudies = this.userData.studies.filter((study: any) => {
      // Safely handle undefined properties
      const studyName = study.study_name ? study.study_name.toLowerCase() : '';
      const siteLocation = study.site_location ? study.site_location.toLowerCase() : '';
      const studyStatus = study.study_status ? study.study_status.toLowerCase() : '';
      const dateAssigned = study.date_assigned ? new Date(study.date_assigned) : new Date();
      const completionDate = study.completion_date ? new Date(study.completion_date) : new Date();
  
      // Check if study matches the filters
      const matchesSearchText = studyName.includes(this.searchText.toLowerCase()) ||
        siteLocation.includes(this.searchText.toLowerCase());
      const matchesStatus = studyStatus.includes(this.statusFilter.toLowerCase());
      const matchesStartDate = this.startDateFilter ? dateAssigned >= new Date(this.startDateFilter) : true;
      const matchesEndDate = this.endDateFilter ? completionDate <= new Date(this.endDateFilter) : true;
  
      return matchesSearchText && matchesStatus && matchesStartDate && matchesEndDate;
    });
  }


  goBack(): void {
    this.router.navigate(['/users-list'], {
      queryParams: {
        page: this.currentPage,
        searchText: this.searchText,
        searchSite: this.searchSite,
        designationFilter: this.designationFilter,
        statusFilter: this.statusFilter
      }
    });
  }

  
}
